export default __webpack_public_path__ + "static/media/icone gravida.d44f62c4.svg";